import React from 'react';
import { StarIcon } from 'lucide-react';
export type Testimonial = {
  quote: string;
  author: string;
  /** City, or city + wedding month. */
  role?: string;
  /** Square photo of the reviewer. */
  avatar?: string;
  /** FTC disclosure, e.g. "Early reader — received a free copy." */
  disclosure?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  background?: 'ivory' | 'white';
};
export function Testimonials({
  testimonials,
  title,
  background = 'white'
}: TestimonialsProps) {
  // Never render empty or invented proof.
  if (testimonials.length === 0) return null;
  return <section aria-label={title ?? 'Testimonials'} className={`w-full ${background === 'ivory' ? 'bg-ivory' : 'bg-white'}`} data-id="element-200" data-mp="2x1kywpwpajvn">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-201" data-mp="2s430vuk81p2f">
        {title && <h2 className="font-serif font-normal text-ink text-[28px] sm:text-[38px] text-center" data-id="element-202" data-mp="v72ijof118mc">
            {title}
          </h2>}
        <ul className={`grid grid-cols-1 md:grid-cols-3 gap-6 ${title ? 'mt-10' : ''}`} data-id="element-203" data-mp="h5oqvedtac90">
          {testimonials.map(t => <li key={t.quote} className="flex flex-col rounded border border-sage/20 bg-sand p-6" data-id="element-204" data-mp="m2ycsk1zs5s3">
              <div className="flex items-center gap-0.5" aria-label="5 out of 5 stars" data-id="element-205" data-mp="c6bvg58vjwut">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-sage text-sage" aria-hidden="true" data-id="element-206" data-mp="zwy3hwivph4t" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-grow font-serif text-ink text-[18px] leading-relaxed" data-id="element-207" data-mp="q4jy8tsldsdw">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <footer className="mt-auto pt-6 flex items-center gap-3" data-id="element-208" data-mp="1iuifw44gin8j">
                {t.avatar && <img src={t.avatar} alt="" loading="lazy" width={96} height={96} className="w-11 h-11 flex-shrink-0 rounded-full object-cover" data-id="element-209" data-mp="1nmsdm6btcrld" />}
                <span className="text-[13px] text-ink-soft" data-id="element-210" data-mp="1ofrecotsaand">
                  <span className="block font-semibold text-ink text-[14px]" data-id="element-211" data-mp="1jir7ibp413v7">
                    {t.author}
                  </span>
                  {t.role && <span className="block mt-0.5" data-id="element-212" data-mp="1ekpsc1ut1op0">{t.role}</span>}
                  {t.disclosure && <span className="block mt-0.5 italic text-ink-muted text-[12px]" data-id="element-213" data-mp="19r3o8y2pit4t">
                      {t.disclosure}
                    </span>}
                </span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}